<template>
  <div
    id="accordionExample"
    class="accordion mb-4 w-full"
  >
    <div class="accordion-item w-full border border-gray-200 bg-white">
      <h2
        id="headingOne"
        class="mb-0 flex"
      >
        <button
          class="accordion-button relative flex w-full items-center rounded-none border-0 bg-white p-2 text-left text-base text-gray-800 transition focus:outline-none"
          @click="toggleAccordion"
        >
          <span
            :class="[showItem ? 'text-body-color' : 'text-gray-over-dark']"
            class="flex-1 text-1md"
          >
            {{ title }}
          </span>
          <transition
            name="arrow"
            mode="out-in"
          >
            <img
              v-if="showItem"
              class="mx-3"
              src="@/assets/arrow-up-black.svg"
              alt="down arrow icon"
            />
            <img
              v-else
              class="mx-3"
              src="@/assets/arrow-down-black.svg"
              alt="down arrow icon"
            />
          </transition>
        </button>
      </h2>
      <transition name="fade">
        <div
          v-if="showItem"
          class="border-t"
        >
          <div
            class="accordion-body px-5 py-4 text-left text-xxs text-body-color md:text-1md"
            v-html="text"
          />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccordionSelect',
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showItem: false,
    };
  },
  methods: {
    toggleAccordion() {
      this.showItem = !this.showItem;
    },
  },
};
</script>

<style scoped>
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  max-height: 0px;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease-out;
  max-height: 250px;
}

.arrow-enter-from,
.arrow-leave-to {
  opacity: 0;
}

.arrow-enter-active,
.arrow-leave-active {
  transition: opacity 0.2s ease-out;
}
</style>
